export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-switch-bar/index.js